import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';
import api from '../../../services/api';
import { getSubdomainUsername, getUsernameSyncOnly } from '../../../utils/subdomain';

const PublicFAQ = () => {
  const { username: urlUsername } = useParams();
  const subdomainUser = getSubdomainUsername();
  const cachedCustomDomainUser = getUsernameSyncOnly();
  const username = urlUsername || subdomainUser || cachedCustomDomainUser;

  const [faqData, setFaqData] = useState({ section: null, faqs: [] });
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const res = await api.get(`/business/faq/public/${username}/`);
        // API returns array directly or object with items
        const faqs = Array.isArray(res.data) ? res.data : (res.data.faqs || res.data.items || []);
        setFaqData({
          section: res.data.section || {},
          faqs: faqs
        });
      } catch (err) {
        console.error('Error fetching FAQ:', err);
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchFAQ();
  }, [username]);

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  // Always render something so navigation scroll target exists
  if (!faqData.faqs.length) {
    return (
      <div id="section-faq" style={{ padding: '4rem 2rem', textAlign: 'center', backgroundColor: '#0f172a' }}>
        <p style={{ color: 'rgba(255,255,255,0.5)' }}>No FAQs available yet.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '4rem 2rem', backgroundColor: '#0f172a' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#fff', marginBottom: '0.5rem' }}>
            {faqData.section?.title || 'Frequently Asked Questions'}
          </h2>
          {faqData.section?.subtitle && (
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem' }}>
              {faqData.section.subtitle}
            </p>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {faqData.faqs.map((faq, index) => (
            <div
              key={faq.id || index}
              style={{
                backgroundColor: 'rgba(255,255,255,0.05)',
                borderRadius: '1rem',
                overflow: 'hidden',
                border: openIndex === index ? '1px solid #6366f1' : '1px solid transparent'
              }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                style={{
                  width: '100%',
                  padding: '1.25rem 1.5rem',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
              >
                <span style={{ color: '#fff', fontWeight: '500', fontSize: '1.1rem' }}>
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp size={20} style={{ color: '#6366f1' }} />
                ) : (
                  <ChevronDown size={20} style={{ color: 'rgba(255,255,255,0.5)' }} />
                )}
              </button>
              {openIndex === index && (
                <div style={{
                  padding: '0 1.5rem 1.25rem',
                  color: 'rgba(255,255,255,0.7)',
                  lineHeight: '1.7'
                }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicFAQ;
